import * as React from 'react';

import CreateNewProfilesFormExplanationBanner from '../create-new-profiles-upload-form-explanation-banner/CreateNewProfilesFormExplanationBanner';
import CreateNewProfilesEntitiesList from '../create-new-profiles-entities-list/CreateNewProfilesEntitiesList';

import './create-profiles-manual-form.scss';

const CreateProfilesManualForm = (): JSX.Element => (
  <div className="create-profiles-manual-form">
    <div className="create-profiles-manual-form__banner-container">
      <CreateNewProfilesFormExplanationBanner />
    </div>
    <CreateNewProfilesEntitiesList />
  </div>
);

export default CreateProfilesManualForm;
